import { render, staticRenderFns } from "./saleFile.vue?vue&type=template&id=6ac8a2b1&scoped=true&"
import script from "./saleFile.vue?vue&type=script&lang=js&"
export * from "./saleFile.vue?vue&type=script&lang=js&"
import style0 from "./saleFile.vue?vue&type=style&index=0&id=6ac8a2b1&scoped=true&lang=css&"
import style1 from "./saleFile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8a2b1",
  null
  
)

export default component.exports